import { useState, useRef } from "react";
import { Routes, Route, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AboutUsPage } from "./AboutUs";
import ContactUs from "./components/ContactUs";
import { MachineryPage } from "./Machinery";
import WhatsAppButton from "./components/WhatsappButton";
import { ProductsPage } from "./Products";
import { BlogPage } from "./Blog";
import { ContactUsPage } from "./ContactUs";
import { QualityPage } from "./Quality";

// Main component that wraps all routes
export function Main() {
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/sobre-nosotros" element={<AboutUsPage />} />
        <Route path="/maquinaria" element={<MachineryPage />} />
        <Route path="/productos" element={<ProductsPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/contacto" element={<ContactUsPage />} />
        <Route path="/sistema-de-calidad" element={<QualityPage />} />
      </Routes>
      <WhatsAppButton />
    </>
  );
}

// Home page component that includes all sections
export function HomePage() {
  return (
    <main>
      <HomePageContent />
      <Service />
      <Solutions />
      <KnowMore />
      <Products />
      <ContactUs />
    </main>
  );
}

function HomePageContent() {
  const [showVideoModal, setShowVideoModal] = useState(false);
  const { t } = useTranslation();

  return (
    <div
      className="py-16 relative"
      style={{
        backgroundImage: "url(/assets/img/main-background.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container px-8 md:px-[100px] md:py-[130px] relative z-10">
        <h1 className="text-left md:leading-[64px] text-[40px] md:text-5xl font-light text-white mb-8">
          {t('MainPage.hero.title')}{" "}
          <span className="font-medium">
            {t('MainPage.hero.titleBold')}
          </span>{" "}
          {t('MainPage.hero.titleEnd')}
        </h1>
        <p className="text-left text-lg md:text-2xl font-extralight text-white mx-auto mb-8 transition-all duration-1000 delay-300 transform">
          {t('MainPage.hero.subtitle')}
        </p>
        <div className="flex my-6 gap-4 transition-all duration-1000 delay-600 transform ">
          <Link
            to="/contacto#form"
            className="bg-[#0096DA] hover:bg-[#05B2F5] transition-all duration-300 text-white text-sm md:text-base py-[8px] px-[25px] rounded-3xl"
          >
            {t('MainPage.hero.contactButton')}
          </Link>
          <button
            onClick={() => setShowVideoModal(true)}
            className="bg-transparent border border-white hover:text-[#0B4494] hover:border-[#0B4494] transition-all duration-300 text-white text-sm md:text-base py-[8px] px-[30px] rounded-3xl"
          >
            {t('MainPage.hero.videoButton')}
          </button>
        </div>
        <div
          className={`mt-12 md:mt-28 transition-all duration-1000 delay-600 transform`}
        >
          <div>
            <div className="md:container md:px-8">
              <div className={`transition-all duration-1000 delay-`}>
                <div className="flex mb-2 md:space-x-6">
                  <div className="flex items-center text-3xl md:text-5xl text-left leading-[120%] font-semibold text-white">
                    40
                    <span className="text-white">+</span>
                    <p className="mx-4 font-extralight text-white md:text-xl text-xs">
                      {t('MainPage.hero.yearsExperience')}
                    </p>
                  </div>
                  <div className="w-[1px] h-[58px] bg-white" />
                  <div className="flex items-center text-3xl md:text-5xl text-left leading-[120%] font-semibold text-white">
                    200
                    <span className="text-white">+</span>
                    <p className="mx-4 font-extralight text-white md:text-xl text-xs">
                      {t('MainPage.hero.satisfiedClients')}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Video Modal */}
      {showVideoModal && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
          <div className="relative bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-hidden">
            <button
              onClick={() => setShowVideoModal(false)}
              className="absolute top-4 right-4 z-10 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 transition-all duration-200 hover:scale-110"
            >
              <svg
                className="w-6 h-6 text-gray-800"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <video
              src="/assets/video/institutional.mp4"
              className="w-full h-full object-contain"
              controls
              autoPlay
              preload="metadata"
            >
              {t('MainPage.hero.videoNotSupported')}
            </video>
          </div>
        </div>
      )}
    </div>
  );
}

function Service() {
  const { t } = useTranslation();

  const descriptions = [
    {
      desc: t('MainPage.service.feature1'),
      href: "/maquinaria",
      target: "_self",
    },
    {
      desc: t('MainPage.service.feature2'),
      href: "/sistema-de-calidad",
      target: "_self",
    },
    {
      desc: t('MainPage.service.feature3'),
      href: "/sobre-nosotros#porque-elegirnos",
      target: "_self",
    },
  ];
  return (
    <div className="bg-[#F2F6FB] relative md:pb-32 pb-16 w-full">
      <img
        className="absolute top-0 left-0 z-0"
        src="/assets/img/diagonal-left.png"
        alt="Diagonal"
        loading="lazy"
        decoding="async"
      ></img>
      <div className="px-8 md:px-[100px] md:pt-[130px] pt-16 relative z-10">
        <div className={`space-y-28 transition-all duration-1000 delay-600`}>
          <div className="md:flex space-y-12 md:space-y-0 gap-x-16">
            <div className="w-full flex flex-col space-y-8">
              <h2 className="text-4xl font-normal text-left leading-[50px]">
                {t('MainPage.service.title')}
              </h2>
              <img
                src="/assets/img/100.jpg"
                alt="Our Process"
                className="rounded-lg"
                loading="eager"
                decoding="async"
                fetchPriority="high"
              />
            </div>
            <div className="w-full text-left ">
              <div className="text-xl font-medium mb-14">
                <p className={`text-gray-500`}>
                  {t('MainPage.service.description1')}
                </p>
                <p
                  className={`text-[#013B8F] italic transition-all duration-1000 transform`}
                >
                      {t('MainPage.service.description2')}
                </p>
              </div>

              <p className="text-xl font-semibold text-[#222222] my-8">
                {t('MainPage.service.experience')}
              </p>
              <p className="text-lg font-normal leading-[24px] space-y-6">
                {t('MainPage.service.commitment')}
                <br />
                <br />
                {t('MainPage.service.location')}
              </p>
              <div className="my-8">
                {descriptions.map((description) => (
                  <Link to={description.href} target={description.target}>
                    <div className="my-6 flex items-center space-x-2">
                      <img
                        src={`/assets/svg/check.svg`}
                        alt={"check"}
                        loading="lazy"
                        decoding="async"
                      />
                      <p className="hover:text-[#0B4494] transition-all duration-300 text-base font-medium leading-[24px]">
                        {description.desc}
                      </p>
                    </div>
                  </Link>
                ))}
              </div>
              <Link
                to="/sobre-nosotros"
                className="bg-[#0B4494] hover:bg-[#0271BA] transition-all duration-300 text-white text-sm md:text-base py-[8px] px-[25px] rounded-3xl"
              >
                {t('MainPage.service.learnMore')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Solutions() {
  const { t } = useTranslation();
  return (
    <div
      className="py-16 relative"
      style={{
        backgroundImage:
          "linear-gradient(-90deg, rgba(1,78,159,0.7), rgba(0,85,164,0.7), rgba(3,41,96,0.7)), url(/assets/img/solutions.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container px-8 md:px-24 py-6 space-y-16 relative z-10">
        <p className="text-left md:leading-[50px] leading-[30px] md:text-4xl text-2xl font-light text-white">
          {t('MainPage.solutions.title')} <br/> <span className="font-semibold">{t('MainPage.solutions.titleBold')}</span>
        </p>
        <p>
          <p className="md:text-right text-left md:leading-[50px] leading-[30px] md:text-4xl text-2xl font-light text-white">
            {t('MainPage.solutions.subtitle')}<br/>{t('MainPage.solutions.formats')}
          </p>
        </p>
      </div>
    </div>
  );
}

function KnowMore() {
  const { t } = useTranslation();
  const videoElementRef = useRef<HTMLVideoElement | null>(null);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const toggleVideoPlayback = () => {
    const video = videoElementRef.current;
    if (!video) return;
    if (video.paused) {
      void video.play();
    } else {
      video.pause();
    }
  };

  const handlePlay = () => setIsVideoPlaying(true);
  const handlePause = () => setIsVideoPlaying(false);
  const handleEnded = () => setIsVideoPlaying(false);
  return (
    <div className="bg-[#F2F6FB] relative md:pb-32 pb-16 w-full">
      <img
        className="absolute top-0 right-0 z-0"
        src="/assets/img/diagonal-right.png"
        alt="Diagonal"
        loading="lazy"
        decoding="async"
      ></img>
      <div className="px-8 md:px-[100px] relative z-10">
        <div
          className={`space-y-10 pt-12 md:pt-28 transition-all duration-1000 delay-600`}
        >
          <div className="w-full md:flex space-y-12 md:space-y-0 gap-x-16">
            <div className="w-full flex flex-col space-y-8">
              <div className="md:text-[55px] text-[30px] font-normal text-left md:leading-[55px] leading-[30px]">
                <h2>{t('MainPage.knowMore.title')}</h2>
                <div className="flex items-center space-x-4">
                  <b>{t('MainPage.knowMore.company')}</b>
                  <img
                    src="/assets/svg/arrow-down.svg"
                    alt="Arrow Down"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </div>
            </div>
            <p className="w-full text-left md:text-xl text-base text-[#2B2B2E]">
              {t('MainPage.knowMore.description')}
            </p>
          </div>
          <div
            className="relative rounded-lg overflow-hidden transition-all duration-300"
            onClick={toggleVideoPlayback}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                toggleVideoPlayback();
              }
            }}
            aria-label={isVideoPlaying ? "Pausar video" : "Reproducir video"}
          >
            <video
              ref={videoElementRef}
              className="w-full h-auto block transition-all duration-300"
              src="/assets/video/video-3.mp4"
              poster="/assets/img/main-video.png"
              preload="metadata"
              playsInline
              onPlay={handlePlay}
              onPause={handlePause}
              onEnded={handleEnded}
            />
            {!isVideoPlaying && (
              <button
                aria-label="Reproducir video"
                className="absolute inset-0 z-10 flex items-center justify-center transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-white/70"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleVideoPlayback();
                }}
              >
                <img
                  src="/assets/svg/play.svg"
                  alt="Play"
                  className="w-[96px] h-[96px] md:w-[120px] md:h-[120px]"
                  loading="lazy"
                  decoding="async"
                />
              </button>
            )}
            {!isVideoPlaying && (
              <div
                className="absolute inset-0 transition-all duration-300 pointer-events-none"
                style={{
                  backgroundColor: "#46517B80",
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function Products() {
  const { t } = useTranslation();
  
  const products = [
    t('MainPage.products.list.galvanized'),
    t('MainPage.products.list.coldRolled'),
    t('MainPage.products.list.pickled'),
    t('MainPage.products.list.tinPlate'),
    t('MainPage.products.list.hotRolled'),
    t('MainPage.products.list.coldRolledCrude'),
    t('MainPage.products.list.aluminized'),
    t('MainPage.products.list.embossed'),
    t('MainPage.products.list.enamel'),
    t('MainPage.products.list.prePainted'),
  ];
  return (
    <div className="flex">
      <div
        className="bg-gray-50 md:py-16 py-4 relative w-full"
        style={{
          backgroundImage:
            "linear-gradient(180deg, #0C164E, #0B347C, #064592, #0153A3)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container 2xl:px-24 px-8 py-6 space-y-8 relative z-10">
          <p className="text-left leading-[50px] text-4xl font-light text-white">
            {t('MainPage.products.title')}
          </p>
          <div className="grid grid-cols-2 gap-6">
            {products.map((product, index) => (
              <div
                className={`${
                  (Math.floor(index / 2) + index) % 2 === 1
                    ? "bg-[#205195]"
                    : "bg-transparent border border-white"
                } h-[90px] px-6 md:w-[250px] md:rounded-[40px] rounded-2xl flex items-center`}
                key={product}
              >
                <p className=" text-white md:text-xl text-base font-light text-left">
                  {product}
                </p>
              </div>
            ))}
          </div>
          <div className="flex justify-start">
            <Link
              to="/productos"
              className={` hover:bg-[#0B4494] transition-all duration-300 bg-transparent border border-white px-6 py-2 rounded-[40px] flex items-center`}
            >
              <p className=" text-white md:text-md text-base font-light text-left">
                {t('MainPage.products.moreInfo')}
              </p>
            </Link>
          </div>
        </div>
      </div>
      <img
        className="hidden lg:block w-1/2 object-cover"
        src="/assets/img/101.jpeg"
        alt="Products"
        loading="eager"
        decoding="async"
        fetchPriority="high"
      />
    </div>
  );
}
